import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { UPSERT_ASSET_MK } from '../components/UpsertAssetModal/UpsertAssetModal.meta';
import { queryKeys } from './queryKeys';
import { UpsertMiscAssetsDTO } from '../forms/MiscAssets/MiscAssetsForm.meta';

export const UPSERT_MISC_ASSETS_ENDPOINT = '/Consumer/OtherAssetsUpdate/SaveMiscellaneousAsset';

const upsertMiscAssets = (body: UpsertMiscAssetsDTO): Promise<null> => {
  return authFetch(UPSERT_MISC_ASSETS_ENDPOINT, {
    method: 'POST',
    ...httpBodyOptions(body, true),
  });
};

interface Params {
  clientId: string;
}

export const useUpsertMiscAssetsMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(upsertMiscAssets, {
    mutationKey: [UPSERT_ASSET_MK, 'miscAssets'],

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.otherAssets(clientId));
    },
  });
};
